import EventsLab from "@/pages/events/Index";

/** Phase 1B.5 worship-realm events are served by the same /events
 *  module; this lab just pre-filters realm=worship so the user lands
 *  on a focused view from the dashboard. */
export default function WorshipEventsLab() {
  return <EventsLab realm="worship" />;
}
